import { WifiOff, RefreshCw } from 'lucide-react';
import { useAuth } from '@/hooks/use-auth';

/**
 * Shown instead of the app while stored credentials cannot be confirmed with
 * the server (offline, deploy-time 503, rate limit). Nothing is cleared; we
 * re-validate with bounded backoff and the user can force a retry or sign out.
 */
export default function ReconnectScreen() {
  const { retryConnection, logout } = useAuth();
  return (
    <div data-testid="auth-reconnect-screen" className="flex min-h-screen items-center justify-center bg-background px-6">
      <div className="w-full max-w-sm text-left">
        <span className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-amber-400/15 text-amber-500">
          <WifiOff size={22} />
        </span>
        <h1 className="text-2xl font-bold tracking-tight">Reconnecting…</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          We couldn&apos;t reach Founder OS to confirm your session. You&apos;re still signed in — we&apos;ll keep
          retrying in the background.
        </p>
        <div className="mt-6 flex items-center gap-3">
          <button
            type="button"
            onClick={retryConnection}
            data-testid="auth-reconnect-retry-btn"
            className="inline-flex items-center gap-2 rounded-full bg-foreground px-4 py-2 text-sm font-semibold text-background transition-opacity hover:opacity-90"
          >
            <RefreshCw size={14} /> Retry now
          </button>
          <button
            type="button"
            onClick={logout}
            data-testid="auth-reconnect-signout-btn"
            className="text-sm font-medium text-muted-foreground underline-offset-4 hover:underline"
          >
            Sign out instead
          </button>
        </div>
      </div>
    </div>
  );
}
